import React from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Fade } from 'react-slideshow-image';
// import StarBorderIcon from '@mui/icons-material/StarBorder';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
// import ChatIcon from '@mui/icons-material/Chat';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
// import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
// import Divider from '@mui/material/Divider';
// import Typography from '@mui/material/Typography';
// import Tooltip from '@mui/material/Tooltip';
// import PersonAdd from '@mui/icons-material/PersonAdd';
// import Settings from '@mui/icons-material/Settings';
// import Logout from '@mui/icons-material/Logout';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
const fadeImages = [
  {
    url: 'https://images.unsplash.com/photo-1509721434272-b79147e0e708?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
    caption: 'Slide 1'
  },
  {
    url: 'https://images.unsplash.com/photo-1506710507565-203b9f24669b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1536&q=80',
    caption: 'Slide 2'
  },
  {
    url: 'https://images.unsplash.com/photo-1536987333706-fc9adfb10d91?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
    caption: 'Slide 3'
  },
];

function MobileMarkerDetailsSeller() {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className='mainwrapperView'>
      <div className="drawerFixedPatch"></div>
      <div className="drawerWithTop">
        {/* <MobileDrawer /> */}
        <ArrowBackIcon
          className="backArrowMobil"
          onClick={() => navigate("/MobileMarketPlaceSeller")}
        />
        <h1>Product Details</h1>
      </div>
      <div className='ListingView'>
      <div className="famDetailsListInrMob">
      <div className='MenuIconView'>
        <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        >
        <div className='ListOptionIconView'>
          <MenuIcon sx={{fontSize:20, color:'#ffffff'}} />
        </div>
        </IconButton>
        <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&::before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <EditIcon fontSize="small" />
              </ListItemIcon>
              Edit
            </MenuItem>
            <MenuItem onClick={handleClose}>
              <ListItemIcon>
                <DeleteIcon fontSize="small" />
              </ListItemIcon>
              Delete
            </MenuItem>
        </Menu>
      </div>
      <div className='ProductSliderIconView'>
      <div className="slide-container">
      <Fade>
        {fadeImages.map((fadeImage, index) => (
          <div key={index}>
            <img style={{ width: '100%' }} src={fadeImage.url} alt='altimg'/>
          </div>
        ))}
      </Fade>
      
    </div>
    
    </div>
    <div className='ListDateView'>
      <p className='ListDateListTxt'>Listed Date:</p>
      <p className='ListDateTimeTxt'>05/02/2023 10:25 am</p>
    </div>
    <div className='ListPriceView'>
      <p className='ListPriceTxt'>Price: <CurrencyRupeeIcon sx={{fontSize:16}}/> 777.00</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Title :</p>
      <p className='ListNameTxt'>Name</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Contact :</p>
      <p className='ListNameTxt'>0124578</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Category :</p>
      <p className='ListNameTxt'>Women</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Condition :</p>
      <p className='ListNameTxt'>New</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Description :</p>
      <p className='ListNameTxt'>Test Test Test</p>
    </div>
    <div className='ListingTitleName'>
      <p className='ListTitleTxt'>Address :</p>
      <p className='ListNameTxt'>Nashik</p>
    </div>
    </div>
      </div>
    </div>
  )
}

export default MobileMarkerDetailsSeller